const deliveryZipCodes = ["85001", "85002", "85003", "85004", "85005", "85006", "85007", "85008", "85009", "85010", "85011", "85012", "85013", "85014", "85015", "85016", "85017", "85018", "85019", "85020", "85021", "85022", "85023", "85025", "85026", "85027", "85028", "85029", "85030", "85031", "85032", "85034", "85036", "85039", "85040", "85041", "85042", "85044", "85045", "85046", "85048", "85050", "85051", "85053", "85054", "85201", "85202", "85203", "85204", "85205", "85206", "85207", "85208", "85209", "85210", "85211", "85212", "85213", "85215", "85216", "85224", "85225", "85226", "85233", "85234", "85235", "85236", "85244", "85246", "85248", "85249", "85250", "85251", "85252", "85253", "85254", "85255", "85256", "85257", "85258", "85259", "85260", "85261", "85263", "85267", "85271", "85274", "85275", "85277", "85280", "85281", "85282", "85283", "85284", "85285", "85286", "85287", "85288", "85295", "85296", "85297", "85298", "85299"];

document.getElementById("check-delivery").addEventListener("click", function() {
    const inputZip = document.getElementById("zip-code-input").value;
    const result = deliveryZipCodes.includes(inputZip) 
        ? "Yes, we deliver to your area!" 
        : "Sorry, we don't deliver to your area.";
    document.getElementById("delivery-result").textContent = result;
});

// Get the modal element
const modal = document.getElementById("delivery-modal");

// Get the link by title that will trigger the modal
const checkDeliveryLinksByTitle = document.querySelectorAll('a[title="Check Delivery Area"]');

// Get the link by text content that will trigger the modal
const checkDeliveryLinksByText = Array.from(document.querySelectorAll('a.link.animate-arrow')).find(link => link.textContent.trim().startsWith('Check Delivery Area'));

// Get the <span> element that closes the modal
const closeModal = document.getElementsByClassName("close")[0];

// Function to open the modal
function openModal(event) {
  event.preventDefault(); // Prevent the default link behavior
  modal.style.display = "block";
}

// Add event listener to each matching link
if (checkDeliveryLinksByTitle.length > 0) {
  checkDeliveryLinksByTitle.forEach(link => {
    link.addEventListener("click", openModal);
  });
}

// When the user clicks on the link with text content, open the modal
if (checkDeliveryLinksByText) {
  checkDeliveryLinksByText.addEventListener("click", openModal);
}

// When the user clicks on <span> (x), close the modal
closeModal.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target === modal) {
    modal.style.display = "none";
  }
}


